import * as R from 'ramda';
import * as RA from 'ramda-adjunct';
import { pickAs, reverseKeyValue } from '../../../../utility/fp';
import { pick } from 'ramda';

export const createCDate = ({
  venue_city = '',
  booking_start_date = '',
  booking_end_date = '',
  promoter_address1 = '',
  calendar_date_id = '',
  booking_lineup = '',
  venue_url1 = '',
  venue_capacity = '',
  promoter_email1 = '',
  promoter_company_name = '',
  venue_address2 = '',
  venue_name = '',
  booking_curfew = '',
  booking_doors_open = '',
  venue_country = '',
  venue_postalcode = '',
  promoter_phone2 = '',
  promoter_address2 = '',
  venue_phone1 = '',
  venue_address1 = '',
  promoter_vat_no = '',
  contact_first_name = '',
  promoter_company_legalname = '',
  promoter_tax_no = '',
  contact_last_name = '',
  contact_fax1 = '',
  contact_country = '',
  booking_date_name = '',
  booking_location_id = '',
  artists = [],
  contact_postalcode = '',
  promoter_country = '',
  promoter_phone1 = '',
  contact_address1 = '',
  contact_phone1 = '',
  contact_phone2 = '',
  promoter_postalcode = '',
  contact_email1 = '',
  contact_chat3 = '',
  request = '',
  promoter_city = '',
  contact_address2 = '',
  contact_city = '',
  booking_status_id = '',
  booking_status_name = ''
} = {}) => {

  if (!booking_end_date) {
    booking_end_date = booking_start_date;
  }

  try {
    if (typeof artists === 'string' && artists.length > 0) {
      artists = JSON.parse(artists).map(createArtist);
    }
  } catch (error) {
    console.error('CDate has invalid artists JSON STRING');
  }

  return {
    venue_city,
    booking_start_date,
    booking_end_date,
    promoter_address1,
    calendar_date_id,
    booking_lineup,
    venue_url1,
    venue_capacity,
    promoter_email1,
    promoter_company_name,
    venue_address2,
    venue_name,
    booking_curfew,
    booking_doors_open,
    venue_country,
    venue_postalcode,
    promoter_phone2,
    promoter_address2,
    venue_phone1,
    venue_address1,
    promoter_vat_no,
    contact_first_name,
    promoter_company_legalname,
    promoter_tax_no,
    contact_last_name,
    contact_fax1,
    contact_country,
    booking_date_name,
    booking_location_id,
    artists,
    contact_postalcode,
    promoter_country,
    promoter_phone1,
    contact_address1,
    contact_phone1,
    contact_phone2,
    promoter_postalcode,
    contact_email1,
    contact_chat3,
    request,
    promoter_city,
    contact_address2,
    contact_city,
    
    booking_status_id,
    booking_status_name
  }
};


export const createArtist = ({
  performance_time = '',
  artist_before = '',
  performance_time_contract = '',
  artist_after = '',
  artist_soundcheck = '',
  first_offer_notes = '',
  artist_id = '',
  artist_name = ''
} = {}) => {
  return {
    performance_time,
    artist_before,
    performance_time_contract,
    artist_after,
    artist_soundcheck,
    first_offer_notes,
    artist_id,
    artist_name
  }
};

const promoterKeyMap = {
  'promoter_company_name'     : 'company_name'     ,
  'promoter_address1'         : 'address1'         ,
  'promoter_address2'         : 'address2'         ,
  'promoter_city'             : 'city'             ,
  'promoter_postalcode'       : 'postalcode'       ,
  'promoter_country'          : 'country'          ,
  'promoter_phone1'           : 'phone1'           ,
  'promoter_phone2'           : 'phone2'           ,
  'promoter_email1'           : 'email1'           ,
  'promoter_vat_no'           : 'vat_no'           ,
  'promoter_tax_no'           : 'tax_no'           ,
  'promoter_company_legalname': 'company_legalname',
};


const contactKeyMap = {
  'contact_address1': 'address1',
  'contact_address2': 'address2',
  'contact_chat3': 'chat3',
  'contact_city': 'city',
  'contact_company_name': 'company_name',
  'contact_id': 'contact_id',
  'contact_country': 'country',
  'contact_email1': 'email1',
  'contact_fax1': 'fax1',
  'contact_first_name': 'first_name',
  'contact_label': 'label',
  'contact_last_name': 'last_name',
  'contact_phone1': 'phone1',
  'contact_phone2': 'phone2',
  'contact_postalcode': 'postalcode',
};

export const cdatePromoterToContact = pickAs(promoterKeyMap);
export const contactToCdatePromoter = pickAs(reverseKeyValue(promoterKeyMap));

export const cdateContactToContact = pickAs(contactKeyMap);
export const contactToCDateContact = pickAs(reverseKeyValue(contactKeyMap));


export const createFinishRequest = pick([
  "calendar_date_id",
  "artist_id",
  "artists",
  "artist_name",
  "first_offer_notes",
  "performance_time",
  "performance_time_contract",
  "artist_before",
  "artist_after",
  "artist_stage_floor",
  "artist_soundcheck",
  "booking_start_date",
  "booking_end_date",
  "booking_date_name",
  "booking_event_url",
  "booking_city",
  "booking_country",
  "booking_lineup",
  "booking_doors_open",
  "booking_curfew",
  "booking_get_in",
  "venue_id",
  "promoter_id",
  "promoter_company_name",
  "promoter_company_legalname",
  "promoter_address1",
  "promoter_address2",
  "promoter_city",
  "promoter_postalcode",
  "promoter_country",
  "promoter_phone1",
  "promoter_phone2",
  "promoter_email1",
  "promoter_vat_no",
  "promoter_tax_no",
  "contact_id",
  "booking_status",
  "venue_name",
  "venue_address1",
  "venue_address2",
  "venue_city",
  "venue_postalcode",
  "venue_country",
  "venue_phone1",
  "venue_url1",
  "venue_capacity",
  "contact_address1",
  "contact_address2",
  "contact_city",
  "contact_postalcode",
  "contact_country",
  "contact_phone1",
  "contact_phone2",
  "contact_email1",
  "contact_fax1",
  "contact_chat3",
  "contact_first_name",
  "contact_last_name"
]);


const demoFinishRequest = {
  "calendar_date_id": "4073",
  "artist_id": "",
  "artists": [
    {
      "artist_name": "DJ Sidious",
      "artist_id": "212",
      "first_offer_notes": "Less Off",
      "performance_time": "45",
      "performance_time_contract": "",
      "artist_soundcheck": "",
      "artist_before": "Kuddus",
      "artist_after": "Bodu",
      "artist_stage_floor": ""
    }],
  "artist_name": "",
  "first_offer_notes": "",
  "performance_time": "",
  "performance_time_contract": "",
  "artist_before": "",
  "artist_after": "",
  "artist_stage_floor": "",
  "artist_soundcheck": "",
  "booking_start_date": "2019-04-11",
  "booking_end_date": "2019-04-11",
  "booking_date_name": "",
  "booking_event_url": "",
  "booking_city": "Berlin",
  "booking_country": "Germany",
  "booking_lineup": "This is the new Line Up",
  "booking_doors_open": "41",
  "booking_curfew": "12",
  "booking_get_in": "dw",
  "venue_id": "204748",
  "promoter_id": "0",
  "promoter_company_name": "Kudduiccha Ltd",
  "promoter_company_legalname": "Kadu",
  "promoter_address1": "21d",
  "promoter_address2": "uh",
  "promoter_city": "978y",
  "promoter_postalcode": "uhj9y",
  "promoter_country": "",
  "promoter_phone1": "98hj9",
  "promoter_phone2": "8h89",
  "promoter_email1": "98h",
  "promoter_vat_no": "1",
  "promoter_tax_no": "23",
  "contact_id": "11684",
  "booking_status": "54",
  "venue_name": "Rang",
  "venue_address1": "Sorauer Str 11",
  "venue_address2": "",
  "venue_city": "Berlin",
  "venue_postalcode": "10997",
  "venue_country": "Germany",
  "venue_phone1": "",
  "venue_url1": "",
  "venue_capacity": "",
  "contact_address1": "null",
  "contact_address2": "null",
  "contact_city": "null",
  "contact_postalcode": "null",
  "contact_country": "",
  "contact_phone1": "null",
  "contact_phone2": "null",
  "contact_email1": "null",
  "contact_fax1": "parma11",
  "contact_chat3": "null",
  "contact_first_name": "Samwise",
  "contact_last_name": "Gamgee"
};
